import React, { useState } from "react";
import Select from "react-select";

import { client_config } from "../../../utils/clientConfigs";
import { trim } from "lodash";
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
} from "reactstrap";
import InputMask from "react-input-mask";
import { toastr } from "react-redux-toastr";

const DEVICE_TYPE_OPTIONS =
  client_config.enabled_features.suppression_list &&
  client_config.enabled_features.suppression_list.length > 0
    ? client_config.enabled_features.suppression_list
    : [];

const SHORT_CODES_OPTIONS = DEVICE_TYPE_OPTIONS.includes("sms")
  ? client_config.sms.short_codes
  : [];

const VOICE_CALLER_ID_OPTIONS =
  (DEVICE_TYPE_OPTIONS.includes("voice") && client_config.voice.caller_id_options) || [];
const EMAIL_ID_OPTIONS =
  DEVICE_TYPE_OPTIONS.includes("email") &&
  client_config.email &&
  client_config.email.address_options
    ? client_config.email.address_options
    : [];

const SuppressionlistModal = (props) => {
  const { isOpen, selected, toggleModal, createAction } = props;

  const [suppressionlistRecord, setSuppressionlistRecord] = useState({
    device_vch: "",
    device_type_vch: "",
    short_code: "",
    caller_id: "",
    fromemail_vch: "", //sender group list of client e.g. aep/heco.....
    ...selected,
  });

  const closeBtn = (
    <button type="button" className="close" onClick={toggleModal}>
      &times;
    </button>
  );

  function updateSuppressionlistRecord({ name, value }) {
    setSuppressionlistRecord({
      ...suppressionlistRecord,
      [name]: value || "",
    });
  }

  async function validateChanges(e) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    if (
      !suppressionlistRecord.device_type_vch ||
      !["sms", "voice", "email"].includes(suppressionlistRecord.device_type_vch)
    ) {
      return toastr.error("Oops", "Please choose contact's device type");
    }

    if (!suppressionlistRecord.device_vch) {
      return toastr.error("Oops", "Please specify the contact device information");
    }

    if (["sms", "voice"].includes(suppressionlistRecord.device_type_vch)) {
      if (suppressionlistRecord.device_vch)
        suppressionlistRecord.device_vch = suppressionlistRecord.device_vch.replace(/[^\d]/g, "");
      if (("" + suppressionlistRecord.device_vch).length - 1 !== 10) {
        return toastr.error(
          "Oops",
          `${suppressionlistRecord.device_type_vch.toUpperCase()} device require 10 digits.`
        );
      }
    }

    if (["email"].includes(suppressionlistRecord.device_type_vch)) {
      if (trim(suppressionlistRecord.device_vch || "") === "") {
        return toastr.error("Oops", "Please specify the contact device information");
      }

      if (!suppressionlistRecord.device_vch.includes("@")) {
        return toastr.error("Oops", `Enter valid Email address.`);
      }
    }

    if (["sms"].includes(suppressionlistRecord.device_type_vch)) {
      if (!suppressionlistRecord.short_code)
        return toastr.error("Oops", "Please choose Short code");
    }

    if (["voice"].includes(suppressionlistRecord.device_type_vch)) {
      if (!suppressionlistRecord.caller_id) return toastr.error("Oops", "Please choose Caller ID");
    }

    Promise.resolve(
      createAction({
        ...suppressionlistRecord,
        device_vch: trim(suppressionlistRecord.device_vch),
      }) && toggleModal(false)
    );
  }

  return (
    <Modal isOpen={isOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal} close={closeBtn}>
        Add Suppression List Record
      </ModalHeader>

      <ModalBody>
        <Row>
          <Col md={6} className="mb-4">
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>Device Type</InputGroupText>
              </InputGroupAddon>
              <Select
                className="flex-fill"
                value={
                  suppressionlistRecord["device_type_vch"]
                    ? {
                        label: suppressionlistRecord["device_type_vch"],
                        value: suppressionlistRecord["device_type_vch"],
                      }
                    : ""
                }
                options={DEVICE_TYPE_OPTIONS.map((type) => ({ label: type, value: type }))}
                onChange={({ value }) =>
                  updateSuppressionlistRecord({ name: "device_type_vch", value })
                }
                placeholder={DEVICE_TYPE_OPTIONS.join(", ")}
              />
            </InputGroup>
          </Col>
        </Row>

        <Row>
          <Col className="mb-4">
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>Device</InputGroupText>
              </InputGroupAddon>

              {!suppressionlistRecord["device_type_vch"] ||
              suppressionlistRecord["device_type_vch"] === "email" ? (
                <Input
                  bsSize="lg"
                  type="text"
                  name="device_vch"
                  value={suppressionlistRecord["device_vch"] || ""}
                  onChange={({ target }) => updateSuppressionlistRecord(target)}
                  placeholder={
                    suppressionlistRecord["device_type_vch"]
                      ? "sample@email.com"
                      : "Please select a device type"
                  }
                  required={true}
                  length={215}
                  disabled={!suppressionlistRecord["device_type_vch"]}
                />
              ) : (
                <InputMask
                  mask="+1 (999) 999-9999"
                  maskChar={null}
                  length={11}
                  value={suppressionlistRecord["device_vch"] || ""}
                  onChange={({ target }) => updateSuppressionlistRecord(target)}
                >
                  {(inputProps) => (
                    <Input
                      bsSize="lg"
                      name="device_vch"
                      placeholder="+1 (123) 456-7890"
                      {...inputProps}
                    />
                  )}
                </InputMask>
              )}
            </InputGroup>
          </Col>
        </Row>

        {suppressionlistRecord.device_type_vch === "sms" && (
          <Row className="mb-2">
            <Col md={6} className="mb-4">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>Short Code</InputGroupText>
                </InputGroupAddon>
                <Select
                  className="flex-fill"
                  value={SHORT_CODES_OPTIONS.filter(
                    ({ value }) => value === suppressionlistRecord.short_code
                  )}
                  options={SHORT_CODES_OPTIONS}
                  onChange={(short_code) => {
                    updateSuppressionlistRecord({ name: "short_code", value: short_code.value });
                  }}
                  placeholder="Select short code"
                />
              </InputGroup>
            </Col>
          </Row>
        )}

        {suppressionlistRecord.device_type_vch === "voice" && (
          <Row className="mb-2">
            <Col md={6} className="mb-4">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>Caller Id</InputGroupText>
                </InputGroupAddon>
                <Select
                  className="flex-fill"
                  value={VOICE_CALLER_ID_OPTIONS.filter(
                    ({ value }) => value === suppressionlistRecord.caller_id
                  )}
                  options={VOICE_CALLER_ID_OPTIONS}
                  onChange={(voice_caller_id_obj) => {
                    updateSuppressionlistRecord({
                      name: "caller_id",
                      value: voice_caller_id_obj.value,
                    });
                  }}
                  placeholder="Select Caller Id"
                />
              </InputGroup>
            </Col>
          </Row>
        )}

        {/*suppressionlistRecord.device_type_vch === "email" && (
          <Row className="mb-2">
            <Col md={6} className="mb-4">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>Sender Address</InputGroupText>
                </InputGroupAddon>
                <Select
                  className="flex-fill"
                  value={EMAIL_ID_OPTIONS.filter(
                    ({ value }) => value === suppressionlistRecord.fromemail_vch
                  )}
                  options={EMAIL_ID_OPTIONS}
                  onChange={(email_address_obj) => {
                    updateSuppressionlistRecord({
                      name: "fromemail_vch",
                      value: email_address_obj.value,
                    });
                  }}
                  placeholder="Select Email From"
                />
              </InputGroup>
            </Col>
          </Row>
        )*/}
      </ModalBody>

      <ModalFooter className="d-flex justify-content-between">
        <Button type="button" color="secondary" onClick={toggleModal}>
          Cancel
        </Button>

        <Button type="button" color="primary" onClick={(e) => validateChanges(e)}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SuppressionlistModal;
